import React from 'react'
import Routes from 'routes'
import { PageFooter, Button, ButtonsGroup, ChapterProgress } from 'components/library'
import { translate } from 'translations'

const AspectFooter = props => (
  <PageFooter>
    <div className="Page-footer-left">
      <Button outline to={Routes.to('home')} icon="home" />
    </div>

    <div className="Page-footer-right">
      <ChapterProgress chapter={props.chapter} aspect={props.aspect} />
      <ButtonsGroup>
        <Button square onClick={props.handleBack} label={translate('app.back')} icon="arrow-left" iconPos="left" />
        <Button primary square onClick={props.handleNext} label={translate('app.next')} icon="arrow-right" iconPos="right" />
      </ButtonsGroup>
    </div>
  </PageFooter>
)

export default AspectFooter


// WEBPACK FOOTER //
// ./src/components/views/chapters/components/AspectFooter.js